<script>
import ProductBox from "@/components/products/ProductBox.vue"
import BreadcrumpsProfil from "@/components/BreadcrumpsProfil.vue";

export default {
  name: 'FavoriteList',
  components: {BreadcrumpsProfil, ProductBox},
  props: {
    favorites: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <section class="y-8 md:py-12 flex-1">
    <div class="mx-auto max-w-screen-xl px-4 2xl:px-0">
      <breadcrumps-profil :second-items="{ text: 'Mes favoris' }" />
      <h2 class="mb-4 text-xl font-semibold text-gray-900 dark:text-white sm:text-2xl md:mb-6">
        Mes favoris
      </h2>
      <div class="mb-4 grid gap-4 sm:grid-cols-2 md:mb-8 lg:grid-cols-3 xl:grid-cols-4">
        <product-box v-for="(favorite, index) in favorites" :key="index" :product="favorite.products" />
      </div>
    </div>
  </section>
</template>
